export const url = `https://www.superheroapi.com/api.php/1187317678426591/search/`
export const characterUrl = `https://superheroapi.com/api.php/1187317678426591/`